import React from 'react';

import face1 from './assets/rating-1.webp';
import face2 from './assets/rating-2.webp';
import face3 from './assets/rating-3.webp';
import face4 from './assets/rating-4.webp';
import face5 from './assets/rating-5.webp';

// The five faces the widget offers when a conversation closes, worst to best.
// The number is what the support service stores; the face is how everyone
// reads it. Images rather than emoji characters — Microsoft's Fluent Emoji
// (MIT), the same files the widget ships — so the inbox shows exactly what the
// customer clicked, whatever OS the agent is on.
export const RATING_FACES: Record<number, { emoji: string; label: string; image: string }> = {
  1: { emoji: '😡', label: 'Very bad', image: face1 },
  2: { emoji: '🙁', label: 'Bad', image: face2 },
  3: { emoji: '😐', label: 'Okay', image: face3 },
  4: { emoji: '😄', label: 'Good', image: face4 },
  5: { emoji: '🤩', label: 'Great', image: face5 },
};

export const RATINGS = [1, 2, 3, 4, 5] as const;

type FaceProps = {
  rating: number;
  size?: number;
  // An accessible name of its own. Off when the label is already written
  // next to the face, so a screen reader doesn't say it twice.
  labelled?: boolean;
  className?: string;
};

export const RatingFace: React.FC<FaceProps> = ({
  rating,
  size = 20,
  labelled = true,
  className,
}: FaceProps) => {
  const face = RATING_FACES[rating];
  if (!face) return null;
  return (
    <img
      src={face.image}
      width={size}
      height={size}
      alt={labelled ? face.label : ''}
      title={face.label}
      draggable={false}
      className={className}
      style={{ width: size, height: size }}
    />
  );
};
